/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Empty/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Empty({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/ActionsColumn/Actions/Content/SyncAction/Content/Action/Empty",
  closePopover
  
}) {
let constantData = 'enabled'
let connectionCurrentLocationResourceStatusValueData = fromData.useDataValue({ viewPath,
context: 'connection',
path: 'current_location_resource.status',
})
let aggregateData = fromAggregate.not(constantData, connectionCurrentLocationResourceStatusValueData)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  closePopover
  
})
let constantData1 = 'enabled'
let connectionCurrentLocationResourceStatusValueData1 = fromData.useDataValue({ viewPath,
context: 'connection',
path: 'current_location_resource.status',
})
let aggregateData1 = fromAggregate.not(constantData1, connectionCurrentLocationResourceStatusValueData1)
let dtColorsBlack = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.black'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="ghost"
 marginTop="auto"
 onClick={onClick}
 data="'enabled'"
 data="connection.current_location_resource.status"
 aggregate="/Data/aggregate.js not"
 disabled={aggregateData}
 closePopover={closePopover}
>
{childProps => (
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 text="Sync patients"
 color={aggregateData1 ? dtColorsNeutral500 : dtColorsBlack}
 data="'enabled'"
 data="connection.current_location_resource.status"
 aggregate="/Data/aggregate.js not"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}